import { Box, Skeleton } from "@mui/material";
export const FilterLoader = () => {
  return (
    <Box sx={{ mt: 3, ml: 2 }}>
      <Skeleton variant="rounded" height={12} width="70%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="80%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="50%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="70%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="60%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="80%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="60%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="60%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="80%" sx={{ mb: 3 }} />
      <Skeleton variant="rounded" height={12} width="60%" sx={{ mb: 3 }} />
    </Box>
  );
};
